import axios from '../utils/axios';

export default function getAllCompanies(recId,params) {
    return (
        axios.get('/admin/' + recId + '/companyManagement/v1/companies',{params})
        .then(res => {
            return res.data
        })
        .catch(err => {
            return err;
        })
    )
}
